import { languageList } from './LocaleUtil/languageList';

const DEFAULT_LANG_ID = 1033;

const cookieMatchRegex = name => `(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`;

function setCookie(name, value, daystToExpire, domain) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime()
        + (daystToExpire * 24 * 60 * 60 * 1000));
    const expirationString = `expires=${expirationDate.toUTCString()}`;
    const domainString = `domain=${domain}`;
    window.document.cookie = `${name}=${value};${expirationString};${domainString};path=/`;
}

function setUnoLangCookieFromId(langId) {
    setCookie('UnoLangId', langId, 14, '.expediapartnercentral.com');
}

function setUnoLangCookieFromLocale(locale) {
    const language = languageList.find(lang => lang.locale === locale);
    const langId = language ? language.langId : DEFAULT_LANG_ID;
    setUnoLangCookieFromId(langId);
}

/**
 *  TODO: 2020-01-09 Dudley Fox: Copied from XDIDHelper. Need to refactor it.

     *  Gets the contents of a cookie
     *
     *  @example
     *    getCookie('mycookie');
     *
     *  @param {String} [name] - name of the cookie
     *  @returns {Object} - The String cookie data or null
     */
function getCookie(name) {
    // Modified from: https://stackoverflow.com/a/25490531/34329
    let b = null;
    try {
        b = document.cookie.match(cookieMatchRegex(name));
    } catch (err) {
        // Silently eat these errors.
        // We will return null on failure.
    }

    return b ? b.pop() : null;
}
const getUlxVisitorId = () => getCookie('hav') || getCookie('DUAID') || getCookie('MC1');

function getAbovCookie() {
    let cookie = getCookie('abov');
    if (cookie && cookie.startsWith('"') && cookie.endsWith('"')) {
        cookie = cookie.slice(1, -1);
    }
    return cookie;
}


export {
    setCookie,
    setUnoLangCookieFromLocale,
    getCookie,
    getAbovCookie,
    cookieMatchRegex,
    getUlxVisitorId
};
